import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state: any) => state.drawerState || initialState;

export const drawerOpenSelector = createSelector(
  selectDomain,
  (state) => state.drawerOpen
);
